import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";

import { UrlPath } from "../../../config/routeConfig";
import { TopBar } from "../../shared/topBar/TopBar";
import { ToastContainer, toast } from "react-toastify";
import { AssetDropDown } from "../../UiComponents/AssetDropDown";
import { getAssestListddlAction } from "../../actions/assetsddlAction";
import { getCategory } from "../../actions/investmentAction";
import {
  SBADropDown,
  SBAMultiSelectCheck,
  SBAComboBox,
} from "../../UiComponents/SBADropDown";
import $ from "jquery";
import {
  EmailruleInsertorUpdate,
  InsertOrUpdateEmailAttachmentSecurity,
  CheckEmailRuleNameExists,
  getEmailAttachmentSecurity,
} from "../../../config/apiConfig";
import { Modal } from "react-bootstrap";
import "./EmailRules.css";
import { sbaAxios } from "../../utils/sbaAxios";
import { getEmailAttachmentSecurityAction } from "../../actions/emailRulesAction";
import { getTaxEntitiesAction } from "../../actions/CommonAction";
import { getCrmDocumentTypesAction } from "../../actions/documentAction";
import { getAssetLists } from "../../actions/assetListAction";
import { SBATextBox } from "../../UiComponents/SBATextBox";

export const AddEmailRules = () => {
  const localAssetId = localStorage.getItem("LocalAssetID");
  const dispatch = useDispatch();
  const history = useNavigate();
  const locationData = useLocation();
  const ActiveTab = locationData.state === null ? 1 : locationData.state;
  const params = useParams();
  const Gstate =
    useSelector((state) => {
      return state;
    }) || {};
  const AssetListDDL = Gstate.assetDDL.assetList || [];
  const AccountNameList = Gstate.common.TaxEntitiesList || [];
  const DocumentTypesData = Gstate.Documents.crmDocumentTypesData || [];
  const AssetDataItems = Gstate.assetDDL.assetList || [];
  const Category = useSelector((state) => state.Category.Category) || [];
  const [showAttachment, SetShowAttchment] = useState(
    ActiveTab === 1 || ActiveTab === 2 ? false : true
  );
  const [showAttachmentOnly, SetShowAttachmentOnly] = useState(true);
  const [linkedEmail, SetLinkedEmail] = useState(false);
  const AttachmentConfig =
    useSelector((state) => state.emailRules.AttachmentSecurity) || [];
  const [emailRuleName, SetEmailRuleName] = useState();
  const [fromAddress, SetFromAddress] = useState();
  const [toAddress, SetToAddress] = useState();
  const [ccAddress, SetCCAddress] = useState();
  const [fromDomains, SetFromDomains] = useState();
  const [subjectContains, SetSubjectContains] = useState();
  const [bodyContains, SetBodyContains] = useState();
  const [attachmentContains, SetAttachmentContains] = useState();
  const [documentTypeId, SetDocumentTypeId] = useState();
  const [field, SetField] = useState();
  const [clientDocumentTypeId, SetClientDocumentTypeId] = useState();
  const [clientAssetId, SetClientAssetId] = useState();
  const [sourceEmail, SetSourceEmail] = useState();
  const [subjectOverride, SetSubjectOverride] = useState();
  const [dateOverrideFormat, SetDateOverrideFormat] = useState();
  const [fieldContains, SetFieldContains] = useState("");
  const [isStandardConfiguration, SetIsStandardConfiguration] = useState(false);
  const [assetId, SetAssetId] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isDropDownDisabled, setIsDropDownDisabled] = useState(false);
  const [AttachmentassetId, SetAttachmentassetId] = useState();
  const [Attachment, SetAttachment] = useState([]);
  const [Password, SetPassword] = useState(" ");
  const [attachassetId, SetAttachAssetId] = useState();
  const [attachassetName, SetAttachAssetName] = useState();
  const [emailAttachmentSecurityId, SetemailAttachmentSecurityId] = useState();
  const [emailAlready, SetemailAlready] = useState(false);
  const [ConfigAttachment, setConfigAttachment] = useState();
  const [assetDDLlist, setAssetDDLlist] = useState(AssetListDDL);
  const [accountName, SetAccountName] = useState([]);
  const [selectedOption, setSelectedOption] = useState("account");
 const [selectedDateOverrideOption, setSelectedDateOverrideOption] = useState(1);
 const [resulttrim, setResulttrim] = useState();

  useEffect(() => {
    document.title = `Add Email Rule`;
 },[]);
  useEffect(() => {
    setAssetDDLlist(AssetListDDL);
  }, [AssetListDDL]);
  useEffect(() => {
    dispatch(getAssestListddlAction());
    dispatch(getCategory());
    dispatch(getEmailAttachmentSecurityAction(null));
    dispatch(getCrmDocumentTypesAction());
    dispatch(getAssetLists());
  }, []);
  const AssetDDChanged = (e) => {
    SetAssetId([...e.value]);
  };
  const AttachAssetDDChanged = (e) => {
    SetAttachmentassetId((value) => e.value);
    SetAttachAssetId(e.value.AssetId);
    SetAttachAssetName(e.value.AssetName);
  };

  const NavigatetoEmailRules = () => {
    history(`${UrlPath.EmailRulesList}${localAssetId}`, { state: ActiveTab });
  };
  const standardoncheck = () => {
    var config = $("#stdconfig").prop("checked");
    if (config === true) {
      SetShowAttchment(true);
    } else {
      SetShowAttchment(false);
    }
    SetIsStandardConfiguration(config);
  };
  const attachmentoncheck = () => {
    var config = $("#attachmentonly").prop("checked");
    if (config === true) {
      SetShowAttachmentOnly(true);
    } else {
      SetShowAttachmentOnly(false);
    }
  };
  const linkedEmailOncheck = () => {
    var config = $("#linkedEmail").prop("checked");
    if (config === true) {
      SetLinkedEmail(true);
    } else {
      SetLinkedEmail(false);
    }
  };
  const dateOverrideByOnChange = (value) => {
    setSelectedDateOverrideOption(value)
  };
    const txtRuleChange = (event) => {
        const result = SBATextBox(event.target.value)
        setResulttrim(result);
    SetEmailRuleName(event.target.value);

    sbaAxios({
      url: `${CheckEmailRuleNameExists}${ActiveTab},${event.target.value}`,
      method: "get",
    }).then((response) => {
      SetemailAlready(response);
    });
  };

  const txtFromAddressChange = (event) => {
    SetFromAddress(event.target.value);
  };
  const txtToAddressChange = (event) => {
    SetToAddress(event.target.value);
  };

  const txtCCAddressChange = (event) => {
    SetCCAddress(event.target.value);
  };
  const txtFromDomainsChange = (event) => {
    SetFromDomains(event.target.value);
  };
  const txtSubjectContainsChange = (event) => {
    SetSubjectContains(event.target.value);
  };
  const txtAttachmentContainsChange = (event) => {
    SetAttachmentContains(event.target.value);
  };
  const txtBodyContainsChange = (event) => {
    SetBodyContains(event.target.value);
  };

  const txtSourceEmailChange = (event) => {
    SetSourceEmail(event.target.value);
  };
  const DocumentTypeonChange = (e) => {
    SetDocumentTypeId(e.value.ActivitySubTypeId);
  };
  const FieldOnChange = (e) => {
    SetField(e.value.value);
  };
  const ClientDocumentTypeonChange = (e) => {
    SetClientDocumentTypeId(e.value.DocumentTypeId);
  };
  const ClientAssetNameonChange = (e) => {
    SetClientAssetId(e.value.AssetId);
  };
  const txtSubjectOverrideChange = (event) => {
    SetSubjectOverride(event.target.value);
  };
  const txtDateOverrideFormatChange = (event) => {
    SetDateOverrideFormat(event.target.value);
  };
  const txtFieldContainsChange = (event) => {
    SetFieldContains(event.target.value);
  };
  const txtpasswordChange = (event) => {
    SetPassword(event.target.value);
  };

  const closeModal = () => {
    setShowModal(false);
  };
  const configModal = (Mode) => {
    setShowModal(true);
    if (Mode === "Edit") {
      setIsDropDownDisabled(true);

    } else {
      SetAttachmentassetId();
      setIsDropDownDisabled(false);
      SetPassword();
    }
  };

  const AttachmentConfigchange = (e) => {
    SetAttachment(e.value);
    SetemailAttachmentSecurityId(e.value.EmailAttachmentSecurityId);
    SetAttachmentassetId({AssetId:e.value.AssetId,AssetName:e.value.AssetName});
    SetAttachAssetId(e.value.AssetId);
  };

  const txtAccountName = (event) => {
    SetAccountName(event.target.value);
  };

  const getTaxEntities = (e) => {
    const SearchTerm = e.filter.value;
    if (SearchTerm.length > 0) dispatch(getTaxEntitiesAction(SearchTerm));
  };

  useEffect(() => {
    setConfigAttachment(
      AttachmentConfig.map((item, index) => {
        return {
          ...item,
          SecurityId: item.EmailAttachmentSecurityId,
          AssetName: item.AssetName,
          AssetId: item.AssetId
        };
      })
    );
  }, [AttachmentConfig]);

  const addEmailRules = (event) => {
    const AssetIds = assetId.map((Ids) => Ids.AssetId);
    const AccountIds = accountName.map((Ids) => Ids.TaxEntityId);

    event.preventDefault();
    let saveSuccess = true;
    let errorMsg = [];
    // Prepare the data to be sent in the POST request
    const data = {
      EmailRuleId: 0,
      EmailRuleName: emailRuleName,
      EmailRuleTypeId: ActiveTab,
      IsActive: true,
      FilterFromAddresses: fromAddress,
      FilterToAddresses: toAddress,
      FilterCCAddresses: ccAddress,
      FilterFromDomains: fromDomains,
      FilterSubjectContains: subjectContains,
      FilterBodyContains: bodyContains,
      FilterAttachmentContains: attachmentContains,
      DocumentTypeId: ActiveTab === 1 ? documentTypeId : ActiveTab === 2 ? clientDocumentTypeId : null,
      SourceEmail: sourceEmail,
      AccountIdList: ActiveTab === 2 ? AccountIds.join(",") : null,
      AssetIdList: ActiveTab === 1 ? AssetIds.join(",") : ActiveTab === 2 ? clientAssetId : null, 
      SubjectOverride: ActiveTab === 2 ? subjectOverride : null,
      DateOverrideFormat: ActiveTab === 2 ? dateOverrideFormat : null,
      IsAttachmentOnly: ActiveTab === 2 ? showAttachmentOnly : false,
      IsLinkedEmail: ActiveTab === 2 ? linkedEmail : false,
      LinkedEmailFieldId: ActiveTab === 2 ? field : null,
      LinkedEmailFieldContain: ActiveTab === 2 ? fieldContains : null,
      IsStandardConfiguration: isStandardConfiguration,
      emailAttachmentSecurityId: emailAttachmentSecurityId,
      priority: 0,
      dateOverrideBy: selectedDateOverrideOption,
      ModifiedBy: 10039,

    };

    if (emailAlready === true) {
      saveSuccess = false;
      errorMsg.push("Email Rule Name Already Exists");
    } else if ((resulttrim == false) || (!emailRuleName)) {
      saveSuccess = false;
      errorMsg.push("Please Enter Rule Name");
    } else if (!fromAddress && !fromDomains) {
      saveSuccess = false;
      errorMsg.push(
        "At least From Address or From Domains field needs to be filled."
      );
    } /*else if (!subjectContains && !bodyContains) {
      saveSuccess = false;
      errorMsg.push(
        "At least Subject or Body contains field needs to be filled."
      );
    }*/
    else if (isStandardConfiguration) {
      if (ConfigAttachment.length==0) {
        errorMsg.push("Please Add  the Attachment Password Config");
        saveSuccess = false
      }
      else if (!emailAttachmentSecurityId) {
        errorMsg.push("Please Select  the Attachment Password");
        saveSuccess = false
      }
    }
    
    

    if (ActiveTab === 1  ) {
      if (AssetIds.length == 0) {
        saveSuccess = false;
        errorMsg.push("Please Select Asset Name");
      } 
      else if (!documentTypeId) {
        saveSuccess = false;
        errorMsg.push("Please Select Document Type");
      }
    }
    else if (ActiveTab === 2  ) {
       if(AccountIds.length==0)
      {
        saveSuccess = false;
        errorMsg.push("Please Select Account"); 
      }
      else if (!clientDocumentTypeId) {
        saveSuccess = false;
        errorMsg.push("Please Select Document Type");
      }
     else if (linkedEmail)
     {
       if(!field)
       {
        saveSuccess = false;
        errorMsg.push("Please Select Field"); 
      }
      else if(!fieldContains)
      {
        saveSuccess = false;
        errorMsg.push("Contains Should not be Empty"); 
      }
     }
    }
    if (saveSuccess) {
      sbaAxios({
        url: `${EmailruleInsertorUpdate}`,
        method: "post",
        data: data,
      })
        .then((response) => {
          toast.success("Rules Saved Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setTimeout(() => {
            history(`${UrlPath.EmailRulesList}${localAssetId}`, {
              state: ActiveTab,
            });
          }, 1000);
        })

        .catch((error) => {
          console.error(error);
        });
    } else {
      let ErrorString = "";
      errorMsg.map((item) => {
        ErrorString = `${ErrorString}${item} \n`;
      });
      console.log(errorMsg);
      toast.error(ErrorString, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const fieldDropdown = [
    { value: "1", label: "Subject" },
    { value: "2", label: "Body" },
    { value: "3", label: "Attachment" },
  ];

  //-- Add  Attachment Password--
  const InsertOrUpdateEmailAttachment = (event) => {
    event.preventDefault();
    let saveSuccess = true;
    let errorMsg = [];
    // Prepare the data to be sent in the POST request
    const data = {
      EmailAttachmentSecurityId: 0,
      AssetId: attachassetId,
      SecretKey: Password,
      ModifiedBy: 10039,
    };
    if (!attachassetId) {
      saveSuccess = false;
      errorMsg.push("Please select The Asset");
    }

    if (!Password) {
      saveSuccess = false;
      errorMsg.push("Please Enter Password");
    }
    if (saveSuccess) {
      sbaAxios({
        url: `${InsertOrUpdateEmailAttachmentSecurity}`,
        method: "post",
        data: data,
      })
        .then((response) => {
          setShowModal(false);
          SetAttachment({
            AssetId: attachassetId,
            AssetName: attachassetName,
          });
          SetemailAttachmentSecurityId(response);
          sbaAxios({
            url: `${getEmailAttachmentSecurity}?emailAttachmentSecurityId=${response}`,
            method: "get",
          }).then((result) => {
            if (result && result.length > 0) {
              setConfigAttachment(result);
              SetAttachmentassetId({
                AssetId: result[0].AssetId,
                AssetName: result[0].AssetName,
              });
              SetPassword(result[0].SecretKey);
             SetAttachment({SecurityId:result[0].EmailAttachmentSecurityId,AssetName:result[0].AssetName})
            }
          });
        })

        .catch((error) => {
          console.error(error);
        });
    } else {
      let ErrorString = "";
      errorMsg.map((item) => {
        ErrorString = `${ErrorString}${item} \n`;
      });
      console.log(errorMsg);
      toast.error(ErrorString, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };
  const Level = [
    {
      BreadCrumb: "Email Rules >",
      Routes: `${UrlPath.EmailRulesList}${localAssetId}`,
    },
    { BreadCrumb: "Add Rules", Routes: `${UrlPath.AddEmailRules}${params}` },
  ];
  return (
    <div>
      <TopBar label={"Add Email Rule"} />
      <BreadCrumbs Levels={Level} />
      <div id="content" class="asset-detail-screen mainContentData">
        <div class="p-3">
          <div id="manfield" className="p-3 bg-white life-science rounded">
            <div className="row gap-3">
              <div className="col-md-4">
                <div>
                  <label className="label">Source Type</label>
                  <input
                    className="form-control w-75"
                    type="text"
                    value={
                      ActiveTab === 1
                        ? "Investment"
                        : ActiveTab === 2
                        ? "Client"
                        : "Deletion"
                    }
                    disabled
                  />
                </div>
                <div className="my-4">
                  <label className="label">
                    Rule Name<span className="mandatory">*</span>
                  </label>
                  <input
                    className="form-control w-75"
                    type="text"
                    onChange={txtRuleChange}
                  />
                </div>
                <div
                  id="manfield"
                  className="p-2 bg-white life-science rounded"
                >
                  Filtering Rules
                  <div className="my-4">
                    <label className="label">From Addresses</label>
                    <input
                      className="form-control w-75"
                      type="text"
                      onChange={txtFromAddressChange}
                    />
                  </div>
                  <div className="my-4">
                    <label className="label">To Addresses</label>
                    <input
                      className="form-control w-75"
                      type="text"
                      onChange={txtToAddressChange}
                    />
                  </div>
                  <div className="my-4">
                    <label className="label">cc Addresses</label>
                    <input
                      className="form-control w-75"
                      type="text"
                      onChange={txtCCAddressChange}
                    />
                  </div>
                  <div className="my-4">
                    <label className="label">From Domains</label>
                    <input
                      className="form-control w-75"
                      type="text"
                      onChange={txtFromDomainsChange}
                    />
                  </div>
                  <div className="my-4">
                    <label className="label">Subject Contains</label>
                    <input
                      className="form-control w-75"
                      type="text"
                      onChange={txtSubjectContainsChange}
                    />
                  </div>
                  <div className="my-4">
                    <label className="label">Body Contains</label>
                    <input
                      className="form-control w-75"
                      type="text"
                      onChange={txtBodyContainsChange}
                    />
                  </div>
                      <div className="my-4">
                        <label className="label">Attachment Contains</label>
                        <input
                          className="form-control w-75"
                          type="text"
                          onChange={txtAttachmentContainsChange}
                        />
                      </div>
                </div>
              </div>
              <div className="col-md-4">
                {ActiveTab === 2 && (
                  <>
                    {/* <div className="my-4">
                      <label>
                        <input
                          type="radio"
                          value="account"
                          checked={selectedOption === "account"}
                        />
                        Account
                      </label>
                    </div> */}
                    <div className="my-4">
                      <label className="label">Account Name<span className="mandatory">*</span></label>
                      <div>
                        <SBAMultiSelectCheck
                          data={AccountNameList}
                          valueField="TaxEntityId"
                          textField="TaxEntityName"
                          className="w-75"
                          value={accountName}
                          onFilterChange={getTaxEntities}
                          onChange={txtAccountName}
                          tags={
                            accountName?.length > 0
                              ? [
                                  {
                                    text: `${accountName?.length} items selected`,
                                    data: [...accountName],
                                  },
                                ]
                              : []
                          }
                        />
                      </div>
                    </div>
                  </>
                )}
                {ActiveTab === 1 && (
                  <div className="my-4">
                    <label className="label">
                      Asset Name<span className="mandatory">*</span>
                    </label>
                    <div>
                      <SBAMultiSelectCheck
                        data={assetDDLlist}
                        dataItemKey="AssetId"
                        textField="AssetName"
                        className="w-75"
                        onChange={AssetDDChanged}
                        value={assetId}
                        tags={
                          assetId.length > 0
                            ? [
                                {
                                  text: `${assetId.length} items selected`,
                                  data: [...assetId],
                                },
                              ]
                            : []
                        }
                      ></SBAMultiSelectCheck>
                    </div>
                  </div>
                )}
                {ActiveTab === 2 && (
                  <>
                    <div className="my-4">
                      <label className="label">
                        Asset Name 
                      </label>
                      <div style={{ width: "75%" }}>
                        <SBAComboBox
                          textField={"AssetName"}
                          valueField={"AssetId"}
                          data={AssetDataItems}
                          onChange={ClientAssetNameonChange}
                        />
                      </div>
                    </div>
                    <div className="my-4">
                      <label className="label">
                        Document Type<span className="mandatory">*</span>
                      </label>
                      <div style={{ width: "75%" }}>
                        <SBADropDown
                          textField={"TypeName"}
                          valueField={"DocumentTypeId"}
                          data={DocumentTypesData}
                          onChange={ClientDocumentTypeonChange}
                        />
                      </div>
                    </div>
                  </>
                )}
                {ActiveTab === 1 && (
                  <div className="my-4">
                    <label className="label">
                      Document Type <span className="mandatory">*</span>
                    </label>
                    <div style={{ width: "75%" }}>
                      <SBADropDown
                        textField={"ActivitySubType"}
                        valueField={"ActivitySubTypeId"}
                        data={Category}
                        onChange={DocumentTypeonChange}
                      />
                    </div>
                  </div>
                )}
                {ActiveTab === 1 ||
                  (ActiveTab === 2 && (
                    <div className="my-4">
                      <label className="label">Source/Email</label>
                      <input
                        className="form-control w-75"
                        type="text"
                        onChange={txtSourceEmailChange}
                      />
                    </div>
                  ))}
                {ActiveTab === 2 && (
                  <>
                    <div className="my-4">
                      <label className="label">Subject Override</label>
                      <input
                        className="form-control w-75"
                        type="text"
                        onChange={txtSubjectOverrideChange}
                      />
                    </div>

                    <div
                      id="manfield"
                      className="p-2 bg-white life-science rounded"
                    >
                      <div className="mb-4">
                        <label className="label">Date Override</label>
                        <input
                          className="form-control w-75"
                          type="text"
                          onChange={txtDateOverrideFormatChange}
                        />
                      </div>

                      <div>
                      <label style={{ display: "flex", alignItems: "center" }}>
                          <input
                            type="radio"
                            value="overridesubject"
                            checked={
                              selectedDateOverrideOption === 1
                            }
                            onClick={() => dateOverrideByOnChange(1)}
                            style={{ marginRight: "10px" }}
                          />
                          <span>Override Subject</span> 
                        </label>
                      </div>

                      <div >
                      <label style={{ display: "flex", alignItems: "center" }}>
                          <input
                            type="radio"
                            value="overridebody"
                            checked={
                              selectedDateOverrideOption === 2
                            }
                            onClick={() => dateOverrideByOnChange(2)}
                            style={{ marginRight: "10px" }}
                          />
                          <span>Override Body</span>
                        </label>
                      </div>

                      <div >
                      <label style={{ display: "flex", alignItems: "center" }}>
                          <input
                            type="radio"
                            value="overrideattachment"
                            checked={
                              selectedDateOverrideOption === 3
                            }
                            onClick={() => dateOverrideByOnChange(3)}
                            style={{ marginRight: "10px" }}
                          />
                          <span>Override Attachment</span>
                        </label>
                      </div>
                    </div>                    

                    <div className="my-4">
                      <label style={{ display: "flex", alignItems: "center" }}>
                        <input
                          className="me-1"
                          type="checkbox"
                          onClick={linkedEmailOncheck}
                          id="linkedEmail"
                        />
                        <span>Linked Email</span>
                      </label>
                    </div>
                    {linkedEmail && (
                      <>
                        <div>
                          <div>
                            <label className="label">Field<span className="mandatory">*</span></label>
                            <div>
                              <SBADropDown
                                className="form-control w-50"
                                textField={"label"}
                                valueField={"value"}
                                data={fieldDropdown}
                                onChange={FieldOnChange}
                              />
                            </div>
                          </div>
                          <div>
                            <label className="label">Contains<span className="mandatory">*</span></label>
                            <input
                              className="form-control w-50"
                              type="text"
                              onChange={txtFieldContainsChange}
                            />
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}
                {ActiveTab === 1 ||
                  (ActiveTab === 2 && (
                    <div className="my-4">
                      <label style={{ display: "flex", alignItems: "center" }}>
                        <input
                          className="me-1"
                          type="checkbox"
                          onClick={standardoncheck}
                          id="stdconfig"
                        />
                        <span>Standard Configuration</span>
                      </label>
                    </div>
                  ))}
                {ActiveTab === 3 || ActiveTab === 2 && (
                  <div className="my-4">
                    {showAttachment && (
                      <div>
                        <label className="label">Attachment Password<span className="mandatory">*</span></label>
                        <div className="col-lg-12 d-flex gap-3  p-0 align-items-center">
                          <div style={{ width: "75%" }}>
                            <SBADropDown
                              data={ConfigAttachment}
                              textField={"AssetName"}
                              valueField={"SecurityId"}
                              value={Attachment}
                              onChange={AttachmentConfigchange}
                            ></SBADropDown>
                          </div>
                          <div
                            className="d-flex gap-4"
                            style={{ marginTop: "-4%" }}
                          >
                            <div
                              className="position-absolute edit_iconShareClass"
                              onClick={() => configModal("Edit")}
                            >
                              <i class="fa-solid fa-pencil SBA_icon"></i>
                            </div>
                          </div>
                          <div className="d-flex gap-4"></div>
                          <div
                            className="d-flex gap-2"
                            style={{ marginTop: "-4%" }}
                          >
                            <div
                              className="position-absolute add_iconShareClass"
                              onClick={() => configModal("Add")}
                            >
                              <i class="fa-solid fa-add SBA_icon"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {ActiveTab === 2 && (
                  <div className="my-4">
                  <label style={{ display: "flex", alignItems: "center" }}>
                    <input
                      className="me-1"
                      type="checkbox"
                      checked={showAttachmentOnly}
                      onClick={attachmentoncheck}
                      id="attachmentonly"
                    />
                    <span>Attachment Only</span>
                  </label>
                </div>
                )}
              </div>

              <div className="col-lg-12 d-flex gap-12 justify-content-lg-end p-0 align-items-center">
                <button
                  className="s-sm-btn mx-1"
                  onClick={NavigatetoEmailRules}
                >
                  Cancel
                </button>
                <button className="p-sm-btn mx-1" onClick={addEmailRules}>
                  Save
                </button>
              </div>
            </div>
          </div>
              </div>
              <ToastContainer></ToastContainer>
      </div>

      <Modal show={showModal}>
        <Modal.Header closeButton onClick={closeModal}>
          <Modal.Title>Attachment Password Config</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <label className="label">Asset Name</label>
            <div style={{ width: "75%" }}>
              <AssetDropDown
                onChange={AttachAssetDDChanged}
                data={AssetListDDL}
                value={AttachmentassetId ? AttachmentassetId : ""}
                popupSettings={{
                  style: "z-index:1051",
                  className: "modalDD",
                }}
                disabled={isDropDownDisabled}
              />
            </div>
            <label className="label">Password</label>
            <div>
              <input
                className="form-control w-75"
                type="text"
                onChange={txtpasswordChange}
                defaultValue={Password}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="s-sm-btn mx-1" onClick={closeModal}>
            Cancel
          </button>
          <button
            className="p-sm-btn mx-1"
            onClick={InsertOrUpdateEmailAttachment}
          >
            Save
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
